export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[],"style":[],"script":[{"hid":"gtm","innerHTML":"\n            (function(w,d,s,l,i){w[l]=w[l]||[];\n              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});\n              var f=d.getElementsByTagName(s)[0],\n              j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';\n              j.async=true;\n              j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl;\n              f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-P7G87HNV');\n          ","type":"text/javascript"},{"hid":"iubenda","src":"https://embeds.iubenda.com/widgets/64de0ab3-157e-4e11-b2d5-8be41e9d1bda.js","type":"text/javascript"}],"noscript":[],"__dangerouslyDisableSanitizersByTagID":{"gtm":["innerHTML"]}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false